import { ChangeEvent } from "react";

export const handleChange_Input: Function = (event: ChangeEvent, setFunction: Function) => {
    setFunction((event.target as HTMLInputElement).value);
}